import React, { useEffect, useState } from 'react';
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { useTheme } from 'styled-components';

interface CustomInputMaskProps {
  name: string;
  id?: string;
  title: string;
  mask: string;
  value?: string;
  readOnly?: boolean;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
  textAlign?: 'left' | 'center' | 'right';
  placeholder?: string;
  'data-testid'?: boolean | string;
}

const CustomInputMask: React.FC<CustomInputMaskProps> = ({
  name,
  id,
  title,
  mask,
  value = '',
  readOnly = false,
  disabled = false,
  onChange,
  required = false,
  textAlign = 'left',
  placeholder,
  'data-testid': dataTestId,
}) => {
  const normalizedValue = value === null || value === undefined ? '' : value;

  const [internalValue, setInternalValue] = useState(normalizedValue);
  const theme = useTheme();

  useEffect(() => {
    setInternalValue(normalizedValue);
  }, [value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setInternalValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  const controlId = id || name;

  const testId =
    typeof dataTestId === 'string'
      ? dataTestId
      : dataTestId
        ? `input-${name}`
        : undefined;

  return (
    <FormGroup controlId={controlId}>
      <FormLabel
        style={{ color: theme.colors.botaoConfirmar }}
        data-testid={testId ? `${testId}-label` : undefined}
      >
        {required ? (
          <>
            <span
              style={{ color: theme.colors.botaoConfirmar, fontWeight: 'bold' }}
            >
              {title}
            </span>
            <span style={{ color: theme.colors.vermelho, fontWeight: 'bold' }}>
              *
            </span>
          </>
        ) : (
          title
        )}
      </FormLabel>
      <FormControl
        as={InputMask}
        mask={mask}
        name={name}
        // id={controlId}
        value={internalValue}
        onChange={handleChange}
        readOnly={readOnly}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        data-testid={testId}
        style={{
          borderRadius: '10px',
          border: `1px solid ${theme.colors.bordaInput}`,
          textAlign: textAlign,
          backgroundColor:
            readOnly || disabled ? '#e9ecef' : theme.colors.white,
          cursor: disabled ? 'not-allowed' : 'auto',
        }}
      />
    </FormGroup>
  );
};

export default CustomInputMask;
